import { render } from "./individual-exclusion-detail.vue?vue&type=template&id=6c14d1a8"
import script from "./individual-exclusion-detail.vue?vue&type=script&lang=js"
export * from "./individual-exclusion-detail.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__